export enum ESourceView {
  ProductEditView,
  ProductCalculationView,
}

export enum EUpdateActionType {
  hidden,
  required,
  lock,
  showToClient,
  hiddenValue,
  aiSuggestion,
  aiSuggestionValue,
  defaultValue,
}

export enum ProductLogActionEnum {
  UpdateParameterToHidden = 0,
  UpdateParameterToShown = 1,
  UpdateParameterToRequired = 2,
  UpdateParameterToNotRequired = 3,
  UpdateParameterToShowInDetails = 4,
  UpdateParameterToHideFromDetails = 5,
  UpdateParameterToEditable = 6,
  UpdateParameterToNotEditable = 7,
  UpdateParameterDefaultValue = 8,
  UpdateParameterExternalValues = 9,
  UpdateParameterValueConfigToHidden = 10,
  UpdateParameterValueConfigToShown = 11,
  ClearParameterValueConfigs = 12,
}
